import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfVerificationService } from '../../service/self-verification.service';
import { ModErrorComponent } from '../../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-my-accesses-authorised-detail',
  templateUrl: './my-accesses-authorised-detail.component.html',
  styleUrls: ['./my-accesses-authorised-detail.component.css']
})
export class MyAccessesAuthorisedDetailComponent implements OnInit {
  @Input()id: string;
  optionMenu=1;
  lang = sessionStorage.getItem('lang');



  access: any;
  constructor(private route: ActivatedRoute, private dataApi: SelfVerificationService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,) {
    this.id = this.route.snapshot.paramMap.get('id');
   }

   ngOnInit() {
    this.spinner.show("loading");
    this.dataApi.getMyAccessesDetail(this.id).subscribe(
      (data)=>{
        if(data){
          this.access= data;
        }
        this.spinner.hide("loading");
      },
      (err)=>{
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      })

  }


  getlang(){

    return sessionStorage.getItem('lang');
  }


}
